/* The dealer-finder script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO web: the live packages page script, 2026-09-17 capture. Two edits only: short ids, and figures of 1,000 and over carry a separator. */

(function () {
  var root = document.documentElement;
  if (!root || root.dataset.xgoDealerFinder) return;
  root.dataset.xgoDealerFinder = '1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO  = 'IntersectionObserver' in window;
  var SENS   = { yes: 'Yes', opt: 'Optional', na: 'Not fitted' };
  /* ---------- dealer network: the closest two, then the form ----------
     The section asks one question and answers it. Nothing is listed
     until a postcode is typed, because a list of eighteen is a
     browsing task and browsing is how a paid visitor leaves.

     A postcode promotes the closest N rows into cards; anything else
     is treated as a plain text search over name, suburb, state and
     address and simply filters the rows.

     Distance is |a - b| on the postcode number. It is not kilometres
     and it never claims to be - it only orders a dozen cards and
     every card still shows its suburb so nobody is misled.

     Promotion MOVES the row node rather than rebuilding it, so the
     Liquid above stays the only place the dealer data is written. */
  var net = root.querySelector('[data-net]');
  if (net) {
    var netForm  = net.querySelector('[data-net-form]');
    var netQ     = net.querySelector('[data-net-q]');
    var netRes   = net.querySelector('[data-net-res]');
    var netTop   = net.querySelector('[data-net-top]');
    var netList  = net.querySelector('[data-net-list]');
    var netCount = net.querySelector('[data-net-count]');
    var netClear = net.querySelector('[data-net-clear]');
    var netAll   = net.querySelector('[data-net-all]');
    var netAllT  = net.querySelector('[data-net-all-t]');
    var netEmpty = net.querySelector('[data-net-empty]');
    var netRows  = [].slice.call(net.querySelectorAll('[data-dlr]'));
    var TOPN     = Math.max(1, parseInt(net.dataset.topn, 10) || 2);
    var NET_AU   = ['QLD', 'NSW', 'ACT', 'VIC', 'TAS', 'SA', 'WA', 'NT'];
    var pcField  = root.querySelector('input[name="postcode"]');
    var fitField = root.querySelector('[data-fitter-field]');
    var listOpen = false;

    /* ---- postcode to an approximate place ----
       Sorting by |postcode - postcode| is not distance. 2480 is
       Lismore and 2609 is Fyshwick in Canberra: 129 apart as
       numbers, 830 km apart on the road. Promoting two dealers as
       "your closest" makes that error the headline, so both sides
       are resolved to a rough coordinate and compared properly.

       One table, used for the visitor's postcode AND for each
       dealer's, so the two are always measured the same way.
       Centroids are region-level - good to roughly a suburb, which
       is all a "who is nearest" question needs. A postcode outside
       every range falls back to the old numeric sort rather than
       guessing. */
    var PC = [
      [1000,2079,-33.87,151.21],[2080,2099,-33.70,151.20],[2100,2249,-33.80,151.15],
      [2250,2263,-33.43,151.34],[2264,2310,-32.93,151.75],[2311,2339,-32.56,151.17],
      [2340,2411,-31.09,150.93],[2412,2499,-28.81,153.28],[2500,2534,-34.42,150.89],
      [2535,2551,-35.71,150.18],[2555,2574,-34.07,150.81],[2575,2594,-34.48,150.42],
      [2600,2619,-35.28,149.13],[2620,2639,-35.35,149.23],[2640,2649,-36.08,146.92],
      [2650,2659,-35.12,147.37],[2900,2914,-35.42,149.09],
      [2660,2699,-34.29,146.05],[2700,2739,-34.72,146.55],[2740,2786,-33.75,150.69],
      [2787,2799,-33.42,149.58],[2800,2879,-33.28,149.10],[2880,2899,-31.96,141.47],
      [3000,3210,-37.81,144.96],[3211,3334,-38.15,144.36],[3335,3399,-37.56,143.85],
      [3400,3489,-36.71,142.20],[3490,3549,-34.19,142.16],[3550,3599,-36.76,144.28],
      [3600,3649,-36.38,145.40],[3650,3699,-36.36,146.32],[3700,3749,-36.72,147.06],
      [3750,3810,-37.70,145.20],[3811,3899,-38.17,146.54],[3900,3999,-38.35,145.19],
      [4000,4207,-27.47,153.03],[4208,4287,-28.05,153.42],[4300,4339,-27.61,152.76],
      [4340,4499,-27.56,151.95],[4500,4519,-27.28,152.98],[4520,4557,-26.79,152.96],
      [4558,4579,-26.66,153.08],[4580,4659,-25.55,152.70],[4660,4679,-24.87,152.35],
      [4680,4699,-23.84,151.26],[4700,4739,-23.38,150.51],[4740,4769,-21.14,149.19],
      [4770,4869,-19.26,146.82],[4870,4899,-16.92,145.77],
      [5000,5199,-34.93,138.60],[5200,5299,-35.55,138.62],[5300,5499,-34.17,140.75],
      [5500,5599,-33.55,138.20],[5600,5699,-32.49,137.77],[5700,5799,-31.13,136.82],
      [6000,6199,-31.95,115.86],[6200,6299,-32.50,116.00],[6300,6399,-34.99,117.88],
      [6400,6429,-31.48,118.28],[6430,6449,-30.75,121.47],[6450,6499,-33.86,121.89],[6500,6599,-30.75,116.00],[6600,6699,-29.70,116.00],
      [6700,6799,-20.74,116.85],
      [7000,7199,-42.88,147.33],[7200,7299,-41.44,147.14],[7300,7499,-41.18,146.35],
      [800,869,-12.46,130.84],[870,899,-23.70,133.88]
    ];
    function pcAt(pc) {
      for (var i = 0; i < PC.length; i++) {
        if (pc >= PC[i][0] && pc <= PC[i][1]) return [PC[i][2], PC[i][3]];
      }
      return null;
    }
    function kmBetween(a, b) {
      var R = 6371, t = Math.PI / 180;
      var dLat = (b[0] - a[0]) * t, dLng = (b[1] - a[1]) * t;
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(a[0] * t) * Math.cos(b[0] * t) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.min(1, Math.sqrt(s)));
    }
    /* Straight-line km when both ends resolve, else null. */
    function netKm(row, here) {
      if (!here) return null;
      var there = pcAt(parseInt(row.dataset.pc, 10) || 0);
      if (!there) return null;
      return kmBetween(here, there);
    }
    /* Centroid to centroid is worth about +/-25 km, so a figure like
       "83 km" would be false precision. Round to something the
       number can actually support. */
    function netRound(d) {
      if (d < 15) return '10';
      if (d < 100) return String(Math.round(d / 10) * 10);
      if (d < 1000) return String(Math.round(d / 25) * 25);
      return String(Math.round(d / 100) * 100);
    }
    /* Sort key: real distance where we have it, the old numeric
       gap where we don't, pushed behind everything measurable. */
    function netAway(row, pc, here) {
      var d = netKm(row, here);
      if (d !== null) return d;
      return 100000 + Math.abs((parseInt(row.dataset.pc, 10) || 0) - pc);
    }

    function netTpl(t, n, q) {
      return String(t || '').replace('[n]', n).replace('[q]', q || '');
    }
    /* Shown above the enquiry form, so the two things they have
       already told us are visibly carried across rather than asked
       for twice. */
    function showPick(name, pc) {
      var pick = root.querySelector('[data-pick]');
      var pickName = root.querySelector('[data-pick-name]');
      if (!pick || !pickName) return;
      if (name) pick.dataset.dlr = name;
      if (pc) pick.dataset.pc = pc;
      var bits = [];
      if (pick.dataset.dlr) bits.push(pick.dataset.dlr);
      if (pick.dataset.pc) bits.push(pick.dataset.pc);
      pickName.textContent = bits.join(' · ');
      pick.hidden = bits.length === 0;
    }
    /* Put every row back in document order, closed and unflagged. */
    function netHome() {
      netRows.forEach(function (r) {
        r.classList.remove('is-top', 'is-open');
        r.hidden = false;
        var f = r.querySelector('[data-net-near]');
        if (f) f.hidden = true;
        var t = r.querySelector('[data-net-t]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!netList) return;
      var frag = document.createDocumentFragment();
      netRows.slice().sort(function (a, b) {
        return (parseInt(a.dataset.i, 10) || 0) - (parseInt(b.dataset.i, 10) || 0);
      }).forEach(function (r) { frag.appendChild(r); });
      netList.appendChild(frag);
    }
    function netReset() {
      netHome();
      listOpen = false;
      if (netRes) netRes.hidden = true;
      if (netList) netList.hidden = true;
      if (netEmpty) netEmpty.hidden = true;
      if (netAll) netAll.setAttribute('aria-expanded', 'false');
      if (netAllT && netAll) netAllT.textContent = netAll.dataset.more;
      if (netQ) netQ.value = '';
      var pk = root.querySelector('[data-pick]');
      if (pk) { delete pk.dataset.pc; showPick(null, null); }
    }
    function netRun() {
      var q = (netQ && netQ.value ? netQ.value : '').trim();
      if (!q) { netReset(); return; }
      var ql = q.toLowerCase();
      var pc = /^\d{3,4}$/.test(q) ? parseInt(q, 10) : null;
      netHome();

      if (pc !== null) {
        var here = pcAt(pc);
        /* A postcode is Australia's: a dealer outside it (its state not
           one of the eight) stays in the full list but is never ranked. */
        var by = netRows.filter(function (r) { return NET_AU.indexOf(r.dataset.state) > -1; }).sort(function (a, b) {
          return netAway(a, pc, here) - netAway(b, pc, here);
        });
        var picked = by.slice(0, TOPN);
        picked.forEach(function (r, i) {
          r.classList.add('is-top');
          if (i === 0) {
            var f = r.querySelector('[data-net-near]');
            if (f) f.hidden = false;
          }
          /* A real distance is worth saying out loud - "about 80 km"
             answers the question the section exists to answer. It is
             only ever shown when both ends actually resolved. */
          var km = r.querySelector('[data-net-km]');
          if (km) {
            var d = netKm(r, here);
            if (d === null || !km.dataset.tpl) { km.hidden = true; }
            else { km.textContent = km.dataset.tpl.replace('[n]', netRound(d)); km.hidden = false; }
          }
          if (netTop) netTop.appendChild(r);
        });
        if (netCount) netCount.textContent = netTpl(netCount.dataset.top, picked.length, q);
        if (netEmpty) netEmpty.hidden = true;
        if (netAll) netAll.hidden = false;
        if (netList) netList.hidden = !listOpen;
        if (pcField && !pcField.value) pcField.value = q;
        showPick(null, q);
      } else {
        var hits = netRows.filter(function (r) {
          return (r.dataset.search || '').indexOf(ql) > -1;
        });
        netRows.forEach(function (r) { r.hidden = hits.indexOf(r) === -1; });
        if (netCount) {
          netCount.textContent = netTpl(hits.length === 1 ? netCount.dataset.one : netCount.dataset.many, hits.length, q);
        }
        if (netEmpty) netEmpty.hidden = hits.length > 0;
        /* A name search is a browse, so the matches ARE the answer -
           there is nothing to hide behind a "see all". */
        if (netAll) netAll.hidden = true;
        listOpen = true;
        if (netList) netList.hidden = hits.length === 0;
      }
      if (netRes) netRes.hidden = false;
    }

    /* JavaScript on: the list starts closed. With it off, everything
       above is inert and the full list is simply on the page. */
    if (netList) netList.hidden = true;

    if (netForm) netForm.addEventListener('submit', function (e) {
      e.preventDefault();
      netRun();
      if (netQ) netQ.blur();          /* drop the keyboard so the answer is visible */
    });
    if (netQ) netQ.addEventListener('input', function () {
      if (!netQ.value.trim()) netReset();
    });
    if (netClear) netClear.addEventListener('click', netReset);
    if (netAll) netAll.addEventListener('click', function () {
      listOpen = !listOpen;
      if (netList) netList.hidden = !listOpen;
      netAll.setAttribute('aria-expanded', listOpen ? 'true' : 'false');
      if (netAllT) netAllT.textContent = listOpen ? netAll.dataset.less : netAll.dataset.more;
      if (listOpen && netList) {
        netList.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });
    /* Delegated: a promoted row is a card, not a toggle. */
    net.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-net-t]') : null;
      if (!t) return;
      var r = t.closest('[data-dlr]');
      if (!r || r.classList.contains('is-top')) return;
      var open = r.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    /* The enquiry button on a dealer carries that dealer's name. */
    net.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-net-book]') : null;
      if (!b) return;
      var name = b.dataset.dlrName || '';
      if (fitField) {
        fitField.value = name;
        fitField.classList.add('is-set');
        window.setTimeout(function () { fitField.classList.remove('is-set'); }, 1600);
      }
      showPick(name, null);
    });
  }

})();
